import { useQueryClient } from '@tanstack/react-query';
import { useApplicationLocalStorage } from '../../application-hook';
import { F5ApplicationParameters } from '@platform/client/schemas';
import { useState } from 'react';
import { ApplicationPageProps } from '../../Application';
import { Application } from '@platform/client';
import { RejoinCohortDetails, SignUpCohortDetails } from '../../program/shared/CohortDetails';
import { ErrorBox } from '@platform/components';
import { REVIEW_MODE_STORAGE_KEY, ReviewModeStorage } from '../../../dashboard/home/RejoinPanel';

export const F5ConfirmAndSubmit = (props: ApplicationPageProps) => {
  const [failed, setFailed] = useState(false);
  const { getApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<F5ApplicationParameters>(props.dataKey);
  const rejoinCohort = getApplicationDataByKey('cohortId');

  // clear flag to allow confirmation page to be re-visited.
  const { clearApplicationData: clearReviewModeData } =
    useApplicationLocalStorage<ReviewModeStorage>(REVIEW_MODE_STORAGE_KEY);
  clearReviewModeData();

  const submitF5Mutation = Application.useSubmitF5Application();
  const queryClient = useQueryClient();
  const submit = () => {
    submitF5Mutation.mutate(
      {
        data: {
          cohortId: rejoinCohort ?? null,
          ...getApplicationData(),
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: Application.getGetProfessionalApplicationStatusQueryKey(),
          });
        },
        onError: () => {
          setFailed(true);
        },
      },
    );
  };

  return (
    <>
      {rejoinCohort ?
        <RejoinCohortDetails
          cohortId={parseInt(rejoinCohort)}
          onBack={props.onBack}
          onSubmit={submit}
          isSubmitting={submitF5Mutation.isPending || submitF5Mutation.isSuccess}
        />
      : <SignUpCohortDetails
          onBack={props.onBack}
          onSubmit={submit}
          isSubmitting={submitF5Mutation.isPending || submitF5Mutation.isSuccess}
        />
      }
      {failed && (
        <ErrorBox showAlertTriangle={true}>
          There was an error submitting your application. Please try again later.
        </ErrorBox>
      )}
    </>
  );
};
